var map = {
	"./freespin1_multiplier1.png": 19212,
	"./freespin1_multiplier2.png": 39271,
	"./freespin1_multiplier3.png": 20958,
	"./freespin1_multiplier5.png": 47752,
	"./freespin2_multiplier20.png": 87214,
	"./freespin2_multiplier3.png": 54813,
	"./freespin2_multiplier6.png": 43920,
	"./freespin2_multiplier9.png": 17751,
	"./freespin3_multiplier12.png": 97714,
	"./freespin3_multiplier18.png": 2664,
	"./freespin3_multiplier40.png": 18983,
	"./freespin3_multiplier6.png": 39381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21847;